import { FC, ReactNode, SVGProps } from 'react'
import classes from './emptyState.module.scss'

interface AdLibraryEmptyStateProps {
  description: ReactNode
  icon: FC<SVGProps<SVGSVGElement>>
  title: string
}

export const AdLibraryEmptyState: FC<AdLibraryEmptyStateProps> = ({
  description,
  icon: Icon,
  title,
}) => {
  return (
    <div className={classes.container}>
      <Icon className={classes.icon} />
      <h3 className={classes.title}>{title}</h3>
      <p className={classes.description}>{description}</p>
    </div>
  )
}
